// Create array of text to look for
const textToHide = [
    '$',
    'Pick-Up Date',
    'Pick-Up Time',
    'Accept Terms',
    'Make Cake Gluten-Free',
    'Custom Writing',
    'Add Custom Writing',
    'Title:',
    'Add a Custom Message:',
    'Custom Message:',
]
// console.log(textToHide)

// Get all '.cart-item__details .product-option'
const productOptions = document.querySelectorAll('.cart-item__details .product-option dt')

// Function to check if text matches 
function getHideThisElement(element) {
    let exitLoop = false;

    // Loop through each textToHide
    textToHide.forEach((text) => {
        if( exitLoop ) { return true ;}
    
        // Check if text is included in the element
        if( element.innerText.includes(text) ) {    
            
            // If it is included exit the loop and return true
            exitLoop = true;
        } 
    })

    return exitLoop;
}

// Loop through each product option
productOptions.forEach((element) => {
    const hideThisElement = getHideThisElement(element);    
    if( hideThisElement ) {
        element.parentElement.classList.add('hidden')
    }
})

console.log('Ran')